import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../css/Find.css";
import axios from "axios";
import Footer from "./Footer";
import Header from "./Header";
import AdLeft from "./AdLeft";
import AdRight from "./AdRight";

function IdFind() {
    const [birthDate, setBirthDate] = useState("");
    const navigate = useNavigate();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [elementBox, setElementBox] = useState(false);

    const handleDateChange = (e) => {
        setBirthDate(e.target.value); // 선택된 날짜를 상태로 저장
    }

    const elementToggleBox = () => {
        setElementBox(!elementBox);
    }

    const handleId = () => {
        console.log("Name:", name);
        console.log("BirthDate:", birthDate);
        console.log("Email", email);
        console.log("==========================");
        if (name === "") {
            alert("이름을 입력하세요.")
        }
        else if (birthDate === "") {
            alert("생년월일을 입력하세요.")
        }
        else if (email === "") {
            alert("이메일을 입력하세요.")
        } else {
            const userData = {
                name: name,
                birthDate: birthDate,
                email: email
            };

            const url = `${process.env.REACT_APP_SPRING_API_URL}/api/IdFind`;

            axios
                .post(url, userData)
                .then((response) => {
                    alert(`${name}님의 아이디는 ${response?.data} 입니다`);
                    navigate('/Login');
                })
                .catch((error) => {
                    const msg = error.response?.data || '입니다';
                    alert(msg);
                });
        }
    }


    return (
        <div className="Find">
            <Header />
            {/* 좌측 광고 */}
            <div className="AdLeft-container">
                <AdLeft />
            </div>
            {/* 우측 광고 */}
            <div className="AdRight-container">
                <AdRight />
            </div>
            <header className="Find-header">

                <div className="Find-location-container">
                    <div className="Find-location-element">
                        <div className="Find-location">
                            <button className="Find-location-button" type="button"
                                    onClick={() => navigate("/")}>홈
                            </button>
                        </div>
                        <div className="Find-location-down"></div>
                        <div className="Find-location">
                            <button className="Find-location-button" type="button"
                                    onClick={() => navigate("/login")}>로그인
                            </button>
                        </div>
                        <div className="Find-location-down"></div>
                        <div className="Find-location">
                            <button className="Find-Box-element" onClick={elementToggleBox}>아이디 찾기</button>
                        </div>

                        {elementBox && (
                            <div className="Find-Box" id="myBox">
                                <button className="Find-Box-element" onClick={() => {
                                    setElementBox(false);
                                    navigate("/idfind")}}>아이디 찾기
                                </button>
                                <button className="Find-Box-element" onClick={() => {
                                    setElementBox(false);
                                    navigate("/pwfind")}}>비밀번호 찾기
                                </button>
                                <button className="Find-Box-element" onClick={() => {
                                    setElementBox(false);
                                    navigate("/signup")}}>회원가입
                                </button>
                            </div>
                        )}
                    </div>
                </div>
                <div className="IdFind-container">
                    <div className="Find-container-element">
                        <div className="Find-element-container">
                            <p className="Find-element-box">이름</p>
                            <input
                                className="Find-element-textbox"
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="이름 입력"
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        handleId(); // ✅ 엔터로 검색 실행
                                    }
                                }}
                            />
                        </div>

                        <div className="Find-element-container">
                            <p className="Find-element-box">생년월일</p>
                            <input
                                className="Find-element-textbox"
                                type="date"
                                id="startDate"
                                value={birthDate}
                                onChange={handleDateChange}
                                max="9999-12-31"
                            />
                        </div>

                        <div className="Find-element-container">
                            <p className="Find-element-box">이메일</p>
                            <input
                                className="Find-element-textbox"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="example@example.com"
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        handleId(); // ✅ 엔터로 검색 실행
                                    }
                                }}
                            />

                        </div>

                        {(name === "" || birthDate === "" || email === "") ? (
                            <div className="Find-find-container">
                                <button
                                    className="Find-find-button"
                                    onClick={handleId}
                                    style={{background: "gray"}}
                                >
                                    ID 찾기
                                </button>
                            </div>
                        ) : (
                            <div className="Find-find-container">
                                <button
                                    className="Find-find-button"
                                    onClick={handleId}
                                    style={{background: "darkblue"}}
                                >
                                    ID 찾기
                                </button>
                            </div>
                        )}
                    </div>
                </div>

            </header>
            <Footer />
        </div>
    );
}

export default IdFind;
